import { Stack, Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemCall } from '../../../sic-lib/types/ChannelItem';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { secondsToHumanReadable } from '../../../sic-lib/utils/dateHelpers';
import { isLocalhost } from '../../../utils/environment';
import UserChip from '../../Settings/Users/UserChip';

interface Props {
    channelItem: ChannelItemCall;
    isImpersonated: boolean;
    users: UserInfo[];
}

export default function DetailsTab({ channelItem, isImpersonated, users }: Props) {
    const showDevTools = React.useMemo(() => {
        return isImpersonated || isLocalhost;
    }, [isImpersonated]);

    return (
        <Stack spacing={2}>
            <Typography variant="h6" mb={2}>
                Call Details
            </Typography>
            <Typography component="span" variant="caption">
                Duration
            </Typography>
            <Typography>{secondsToHumanReadable(channelItem.duration)}</Typography>
            <Typography component="span" variant="caption">
                User
            </Typography>
            <UserChip userName={channelItem.userName || ''} users={users} />
            <Typography component="span" variant="caption">
                Status
            </Typography>
            <Typography>{channelItem.statusMessage}</Typography>
            {showDevTools && (
                <>
                    <Typography component="span" variant="caption">
                        CallSid
                    </Typography>
                    <Typography>{channelItem.callSid}</Typography>
                </>
            )}
        </Stack>
    );
}
